<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.choose_payment') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-4" :style="{ marginBottom: heightFloating + 'px'}">
            <div v-if="isOQ[0] && isNotWaroenk">
              <div class="font-18 font-weight-700 ol-black py-2">
                QRIS
              </div>
              <div class="mb-4">
                <div v-ripple class="item-payment-detail" @click="selectPayment(isOQ[1], payments[isOQ[1]], 0, 'QRIS')">
                  <div class="item-payment-detail-wrap">
                    <div class="item-payment-detail-avatar">
                      <img src="@/assets/images/v2/img/payment/qris.png" alt="">
                    </div>
                    <div class="item-payment-detail-content">
                      <div class="item-payment-detail-title">
                        QRIS
                      </div>
                    </div>
                    <div class="ml-2">
                      <div :class="['radio-item-payment', { 'active': selectedPayment[isOQ[1]] ? selectedPayment[isOQ[1]][0] === 0 ? true : false : false }]">
                        <div class="radio-item-payment-select" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isCD[0]">
              <div class="font-18 font-weight-700 ol-black py-2">
                {{ $t('v2.cash') }}
              </div>
              <div class="mb-4">
                <div v-ripple class="item-payment-detail" @click="selectPayment(isCD[1], payments[isCD[1]], 0, $t('v2.pay_at_the_cashier'))">
                  <div class="item-payment-detail-wrap">
                    <div class="item-payment-detail-avatar">
                      <img src="@/assets/images/v2/img/payment/cash.png" alt="">
                    </div>
                    <div class="item-payment-detail-content">
                      <div v-if="$store.state.selected_type === 'DELIVERY' || $store.state.selected_type === 'OL-TAKE-AWAY'" class="item-payment-detail-title">
                        {{ $t('v2.pay_after_receiving_the_order') }}
                      </div>
                      <div v-else class="item-payment-detail-title">
                        {{ $t('v2.pay_at_the_cashier') }}
                      </div>
                    </div>
                    <div class="ml-2">
                      <div :class="['radio-item-payment', { 'active': selectedPayment[isCD[1]] ? selectedPayment[isCD[1]][0] === 0 ? true : false : false }]">
                        <div class="radio-item-payment-select" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isEW[0]">
              <div class="font-18 font-weight-700 ol-black py-2">
                E-Wallet
              </div>
              <div class="mb-4">
                <template v-for="(item, idx) in payments[isEW[1]].detail">
                  <template v-if="item.code === 'ShopeePay'">
                    <div v-if="$vuetify.breakpoint.smAndDown" :key="idx + '-ew'" v-ripple class="item-payment-detail" @click="selectPayment(isEW[1], item, idx, item.name, payments[isEW[1]])">
                      <div class="item-payment-detail-wrap">
                        <div class="item-payment-detail-avatar">
                          <img :src="item.image" :alt="item.name">
                        </div>
                        <div class="item-payment-detail-content">
                          <div class="item-payment-detail-title">
                            {{ item.name }}
                          </div>
                        </div>
                        <div class="ml-2">
                          <div :class="['radio-item-payment', { 'active': selectedPayment[isEW[1]] ? selectedPayment[isEW[1]][0] === idx ? true : false : false }]">
                            <div class="radio-item-payment-select" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-else :key="idx + '-ew'" v-ripple class="item-payment-detail" @click="selectPayment(isEW[1], item, idx, item.name, payments[isEW[1]])">
                    <div class="item-payment-detail-wrap">
                      <div class="item-payment-detail-avatar">
                        <img :src="item.image" :alt="item.name">
                      </div>
                      <div class="item-payment-detail-content">
                        <div class="item-payment-detail-title">
                          {{ item.name }}
                        </div>
                      </div>
                      <div class="ml-2">
                        <div :class="['radio-item-payment', { 'active': selectedPayment[isEW[1]] ? selectedPayment[isEW[1]][0] === idx ? true : false : false }]">
                          <div class="radio-item-payment-select" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="isVA[0]">
              <div :class="['font-18 font-weight-700 ol-black', minimumVA ? 'pt-2' : 'py-2']">
                Transfer Virtual account
              </div>
              <div v-if="minimumVA" class="pb-2 font-14 ol-red">
                {{ $t('v2.minimum_payment') }} <span v-mask-money="Number($store.state.selected_outlet.setting.minimum_payment_amount_va)" />
              </div>
              <div class="mb-4">
                <template v-for="(item, idx) in payments[isVA[1]].detail">
                  <div v-if="item.code !== 'BCA'" :key="idx + '-va'" :v-ripple="!minimumVA" :class="['item-payment-detail prevent-select', { 'disabled': minimumVA }]" @click="!minimumVA && selectPayment(isVA[1], item, idx, item.name, payments[isVA[1]])">
                    <div class="item-payment-detail-wrap">
                      <div class="item-payment-detail-avatar">
                        <img :src="item.image" :alt="item.name">
                      </div>
                      <div class="item-payment-detail-content">
                        <div class="item-payment-detail-title">
                          {{ item.name }}
                        </div>
                      </div>
                      <div class="ml-2">
                        <div :class="['radio-item-payment', { 'active': selectedPayment[isVA[1]] ? selectedPayment[isVA[1]][0] === idx ? true : false : false }]">
                          <div class="radio-item-payment-select" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-if="(selectedPayment.length > 0)" ref="section_floating" class="section-bottom white ol-elevation-1">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                  <div class="mb-4 d-flex align-center">
                    <div class="font-14 font-weight-600">
                      <span v-mask-money="cart.total_pay" />
                    </div>
                    <v-spacer />
                    <div class="font-14 font-weight-600">
                      {{ pay_text }}
                    </div>
                  </div>
                  <v-btn block color="primary" height="40" class="text-none br-5" @click="nextPay()">
                    {{ $t('v2.pay_now') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <v-dialog v-model="dialog.pay_at_cashier" persistent max-width="350" content-class="dialog-pay-at-cashier">
            <v-card>
              <div>
                <div style="position: relative; overflow: hidden; padding: 52px 52px 0 52px;">
                  <div class="background-pay-at-cashier" />
                  <div>
                    <v-img src="@/assets/images/pay_at_cashier.png" :aspect-ratio="1/1" width="240" class="ma-auto" />
                  </div>
                </div>
                <div class="notif-pay-at-cashier">
                  {{ $t('v2.order_status_message' ) }}
                </div>
              </div>
              <div class="pb-6">
                <div class="d-flex" style="gap: 8px; max-width: 264px; margin: auto;">
                  <div style="flex: 1 1 100%;">
                    <v-btn color="white" block class="text-none" @click="dialog.pay_at_cashier = !dialog.pay_at_cashier">
                      {{ $t('v2.cancel3') }}
                    </v-btn>
                  </div>
                  <div style="flex: 1 1 100%;">
                    <v-btn color="primary" block class="text-none" @click="pay()">
                      {{ $t('next') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-dialog>
          <modal-side v-if="dialog.phone" v-model="dialog.phone">
            <template v-slot:modal-title>
              <v-container class="px-0">
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                    <div class="d-flex align-center">
                      <v-btn icon width="40" height="40" class="mr-2" @click="dialog.phone = false">
                        <v-icon>
                          mdi-arrow-left
                        </v-icon>
                      </v-btn>
                      <div class="title-page-text">
                        {{ $t('v2.choose_payment') }}
                      </div>
                      <v-spacer />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-slot:modal-content>
              <v-container class="pt-0">
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
                    <div class="pa-4 ol-elevation-2 br-8 mb-4">
                      <div class="flex-image">
                        <div v-if="!$isEmpty($store.state.selected_outlet)" class="flex-image-avatar mr-4">
                          <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name" class="image-80">
                        </div>
                        <div class="flex-image-content">
                          <div class="flex-image-content-text font-18 font-weight-700 mb-1">
                            {{ $store.state.selected_outlet.name }}
                          </div>
                          <div class="flex-image-content-text font-14 font-weight-400 mb-1">
                            <span v-mask-money="cart.total_pay" />
                          </div>
                          <div class="d-flex align-center">
                            <div class="wrap-table">
                              <div class="wrap-table-icon">
                                <img :src="icon_table" :alt="$t('table')">
                              </div>
                              <div class="wrap-table-content">
                                <div class="wrap-table-text">
                                  {{ $t('v2.eat_in_resto') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
                      <div style="margin-bottom: 64px">
                        <div v-if="!$isEmpty(selectedTypePay)" class="py-2 mb-2">
                          <div class="flex-image">
                            <div class="flex-image-avatar mr-4">
                              <img :src="selectedTypePay.image" :alt="selectedTypePay.code" class="image-40">
                            </div>
                            <div class="flex-image-content">
                              <div class="flex-image-content-text font-14 font-weight-700">
                                {{ selectedTypePay.code }}
                              </div>
                              <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                                {{ $t('v2.enter_phone_number') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-6">
                          <l-a-phone-number v-model="form.phone" :label="$t('fields.phone')" class="inputv2-space" />
                        </div>
                        <div class="pa-4 tnc-phone-input">
                          <div class="mb-2 font-16 font-weight-600">
                            {{ $t('v2.terms_and_conditions') }}
                          </div>
                          <ol class="list-qris-guide">
                            <li>
                              {{ $t('v2.the_application_has_been_installed', { code: selectedTypePay.code }) }}
                            </li>
                            <li>
                              {{ $t('v2.the_balance_is_enough', { code: selectedTypePay.code }) }}
                            </li>
                            <li>
                              {{ $t('v2.your_payment_will_be_forwarded', { code: selectedTypePay.code }) }}
                            </li>
                            <li>
                              {{ $t('v2.payment_is_successful', { code: selectedTypePay.code }) }}
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div v-if="(selectedPayment.length > 0)" class="section-bottom white ol-elevation-1">
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                              <v-btn block color="primary" height="40" class="text-none br-5" @click="payWithPhone()">
                                {{ $t('v2.next') }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </div>
                    </ValidationObserver>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </modal-side>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  getData as getPayment
} from '@/api/payment'
import {
  createOrder
} from '@/api/order'
import {
  ValidationObserver
} from 'vee-validate'
import ModalSide from '@/components/v2/ModalSide'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    ValidationObserver,
    ModalSide,
    LAPhoneNumber
  },
  data() {
    return {
      top_menu: 0,
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      dialog: {
        phone: false,
        pay_at_cashier: false
      },
      pay_text: '',
      selectedTypePay: {},
      selectedPayment: [],
      payments: [],
      cart: {},
      form: {
        payment_mode_id: 0,
        bank_code: '',
        payment_mode_code: '',
        phone: '',
        redirect_url: '',
        shipping_address: '',
        shipping_cost: 0
      },
      tmii: [
        'bellafood',
        'berkahindonesia',
        'bogarasa',
        'buamoy',
        'bugissidrap',
        'dapoerdjiedahalim',
        'dapurbusam',
        'dapurtjikin',
        'dapuryenii',
        'davon',
        'dhiya',
        'elzipo',
        'gadogadobetawi',
        'gubugpecel',
        'heracatering',
        'ibutyia',
        'jengsri',
        'kantinandes',
        'kedaibuimat',
        'kedaifamily',
        'kiosalmahyramnr',
        'kopkartmii',
        'latiffood',
        'mascoco',
        'mbakmarti',
        'mpokjihan',
        'nailadimsum',
        'needsicecream',
        'nusantarafood',
        'pelangifood',
        'pelangi57',
        'pondokminang',
        'purworejofood',
        'rmsolo',
        'sekeco',
        'terasmina',
        'tongsengaslitegal',
        'umimadiun',
        'warungbetawi',
        'warungmarimampir',
        'wongrembang',
        'sab1',
        'sab2'
      ],
      waroenk_store: [
        'waroenkramenklaten',
        'waroenkramenmadiun',
        'waroenkramenpurwodadi',
        'waroenkramenblitar',
        'waroenkramentulungagung',
        'waroenkramenpedan',
        'waroenkramenkudus',
        'waroenkramensidareja',
        'waroenkramenponorogo',
        'waroenkramenpwt',
        'waroenkramennganjuk',
        'waroenkramenjombang',
        'waroenkramenkediri',
        'waroenkramensragen',
        'waroenkramengalmas',
        'waroenkramensolo',
        'waroenkramenkartasura',
        'waroenkramenkebumenpanjer',
        'waroenkramencimanggis',
        'waroenkramenmakassar',
        'waroenkramenkendari',
        'waroenkramentegal',
        'waroenkramenpontianak2',
        'waroenkramenbekasiagussalim',
        'waroenkramenpontianak',
        'waroenkramenbintara',
        'waroenkramenproklamasi',
        'waroenkramensamarinda2',
        'waroenkramenpurbalingga',
        'waroenkramenbalikpapan',
        'waroenkramenjatiwaringin',
        'waroenkramenpurwokertoump',
        'waroenkramensamarindataman',
        'waroenkramenbekasi',
        'waroenkramenmargonda',
        'waroenkramenkelapadua',
        'waroenkramenmeruya'
      ]
    }
  },
  computed: {
    isNotWaroenk() {
      const url = this.$store.state.url_domain
      if (this.waroenk_store.indexOf(url) !== -1) {
        return false
      } else {
        return true
      }
    },
    heightFloating() {
      return this.top_menu
    },
    isOQ() {
      if (this.payments.length > 0) {
        const idx = this.payments.findIndex((e) => e.code === 'OQ')
        const selectedType = this.$store.state.selected_type
        const detailDelivery = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping')
        const isEnabled = this.payments[idx].enabled
        if (idx === -1) {
          return [false, null]
        }

        if (selectedType === 'DELIVERY') {
          if (detailDelivery) {
            const deliveryDetails = JSON.parse(detailDelivery)
            const deliveryType = deliveryDetails.shipping_delivery_type
            if (deliveryType === 2) {
              return [false, null]
            }
            return [isEnabled, idx]
          }
          return [false, null]
        }
        return [isEnabled, idx]
      } else {
        return [false, null]
      }
    },
    isCD() {
      if (this.payments.length > 0) {
        const index = this.payments.findIndex((e) => e.code === 'CD')
        const tmiiLink = this.$store.state.url_domain
        const selectedType = this.$store.state.selected_type
        const selectedUrlId = this.$store.state.url_domain
        const isDevelopment = process.env.NODE_ENV === 'development'
        const authData = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
        const usePayOnTheSpot = this.$store.state.selected_outlet.setting.use_pay_on_the_spot === 1
        const authByGuest = authData.auth_by === 'GUEST'
        const DETAIL_DELIVERY = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping'))
        let shippingDeliveryType = 1
        if (DETAIL_DELIVERY) {
          shippingDeliveryType = DETAIL_DELIVERY.shipping_delivery_type
        }
        if (this.tmii.includes(tmiiLink) || selectedType === 'RESERVATION') {
          return [false, null]
        }
        if (index === -1) {
          return [false, null]
        }
        if (selectedUrlId === 'mastermie' && isDevelopment) {
          return [true, index]
        }
        if (usePayOnTheSpot) {
          if (selectedType === 'DELIVERY') {
            return [!authByGuest && shippingDeliveryType === 1, index]
          } else if (selectedType === 'OL-TAKE-AWAY' || selectedType === 'DINE-IN' || selectedType === 'RESERVATION') {
            return [!authByGuest, index]
          }
        } else {
          if (selectedType === 'DINE-IN' || selectedType === 'RESERVATION') {
            return [true, index]
          }
        }
        return [false, null]
      } else {
        return [false, null]
      }
    },
    isEW() {
      const idx = this.payments.findIndex((e) => e.name === 'E-Wallet')
      if (idx !== -1) {
        if (this.payments[idx].enabled) {
          return [true, idx]
        } else {
          return [false, idx]
        }
      } else {
        return [false, null]
      }
    },
    isVA() {
      const idx = this.payments.findIndex((e) => e.code === 'BT')
      if (idx !== -1) {
        if (this.payments[idx].enabled) {
          return [true, idx]
        } else {
          return [false, idx]
        }
      } else {
        return [false, null]
      }
    },
    minimumVA() {
      if (!this.$isEmpty(this.$store.state.selected_outlet) && !this.$isEmpty(this.$store.state.selected_outlet.setting) && this.$store.state.selected_outlet.setting.active_minimum_payment_amount_va && this.cart.total_pay < Number(this.$store.state.selected_outlet.setting.minimum_payment_amount_va)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    this.getPayments()
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_checkout' }).catch(() => {})
    },
    async getPayments() {
      try {
        const { data } = await getPayment()
        this.payments = data.data
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          this.$router.push({ name: '_phone_check', query: { redirect: this.$route.name }}).catch(() => {})
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async selectPayment(idx, pay_item, index, name, parent_item = null) {
      this.pay_text = ''
      this.selectedPayment = []
      this.pay_text = name
      this.$set(this.selectedPayment, idx, [index])
      this.form.payment_mode_id = pay_item.payment_id

      if (parent_item !== null) {
        if (parent_item.code !== null) {
          this.form.payment_mode_code = parent_item.code
        } else {
          this.form.payment_mode_code = pay_item.code
        }
      } else {
        this.form.payment_mode_code = pay_item.code
      }

      if (this.form.payment_mode_code === 'BT') {
        this.form.bank_code = pay_item.code
      } else {
        delete this.form.bank_code
      }
      this.selectedTypePay = await pay_item
      this.top_menu = await this.$refs.section_floating.clientHeight
    },
    nextPay() {
      if (this.form.payment_mode_code === 'OVO' || this.form.payment_mode_code === 'LINKAJA') {
        this.dialog.phone = true
      } else if (this.form.payment_mode_code === 'CC') {
        // this.currentCardBackground = Math.floor(Math.random() * 11 + 1)
        // this.dialogCC = true
      } else {
        const url_id = this.$store.state.url_domain
        const url_store_popup_pay_on_the_spot = [
          'scr1',
          'scr2',
          'seraqa'
        ]
        if (this.form.payment_mode_id === 10 && url_store_popup_pay_on_the_spot.includes(url_id) && this.$store.state.selected_type === 'DINE-IN') {
          this.dialog.pay_at_cashier = true
          return
        }
        return this.pay()
      }
    },
    async payWithPhone() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.pay()
      }
    },
    async pay() {
      // this.disabled = true
      if (this.dialog.phone === true) {
        this.dialog.phone = false
        document.querySelector('html').style.overflowY = 'scroll'
      }
      var baseDomain = window.location.href
      if (this.form.payment_mode_code === 'CD' || this.form.payment_mode_code === 'BT' || this.form.payment_mode_code === 'OQ') {
        delete this.form.phone
        delete this.form.redirect_url
      } else if (this.form.payment_mode_code === 'LINKAJA' || this.form.payment_mode_code === 'ShopeePay') {
        this.form.redirect_url = baseDomain + '/check'
      } else if (this.form.payment_mode_code === 'OVO') {
        delete this.form.redirect_url
      } else if (this.form.payment_mode_code === 'DANA') {
        delete this.form.phone
        this.form.redirect_url = baseDomain + '/check'
      }

      const LOCAL_DATA_ADDITIONAL = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_additional')
      if (LOCAL_DATA_ADDITIONAL) {
        const parsed = JSON.parse(LOCAL_DATA_ADDITIONAL)

        this.cart = {
          ...this.cart,
          ...parsed
        }
      }

      delete this.form.payment_mode_code

      if (this.$store.state.selected_type !== 'DELIVERY') {
        delete this.form.shipping_address
        delete this.form.shipping_cost
      }
      if (this.$store.state.selected_type === 'DINE-IN') {
        const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
        if (DETAIL_TABLE) {
          const detail_table = JSON.parse(DETAIL_TABLE)
          this.cart.total_guest = detail_table.total_guest
          this.cart.table = detail_table.table
        }
      }
      if (this.$store.state.selected_type === 'RESERVATION') {
        const DETAIL_RESERVATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_detail_reservation')
        if (DETAIL_RESERVATION) {
          const detail_reservation = JSON.parse(DETAIL_RESERVATION)
          this.cart.reserve_date = detail_reservation.reserve_date
          this.cart.reserve_time = detail_reservation.reserve_time
          this.cart.total_guest = detail_reservation.total_guest
          this.cart.email = detail_reservation.email
        }
      }
      if (this.$store.state.selected_type === 'DELIVERY') {
        const DETAIL_DELIVERY = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_shipping')
        const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
        if (DETAIL_DELIVERY && DETAIL_LOCATION) {
          const detail_delivery = JSON.parse(DETAIL_DELIVERY)
          const detail_location = JSON.parse(DETAIL_LOCATION)
          this.cart.shipping_address = detail_location.name + ' -- ' + detail_location.shipping_address
          this.cart.shipping_cost = detail_delivery.shipping_cost
          this.cart.shipping_courier_id = detail_delivery.shipping_courier_id
          this.cart.shipping_courier_name = detail_delivery.shipping_courier_name
          this.cart.shipping_delivery_type = detail_delivery.shipping_delivery_type
          this.cart.shipping_time = detail_delivery.shipping_time
          this.cart.shipping_lat = detail_location.shipping_lat
          this.cart.shipping_lon = detail_location.shipping_lon
          this.cart.shipping_radius = detail_location.shipping_radius
        }
      }
      const selected_type = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type'))
      this.cart.remark = selected_type
      this.$set(this.cart, 'payment', this.form)
      this.cart.item.map(item => {
        if (item.is_takeaway) {
          item.note = 'TAKE AWAY, ' + item.note
        }
      })
      try {
        const { data } = await createOrder(this.cart)
        this.$store.dispatch('saveIdOrder', data.data.id)
        this.$store.dispatch('removeCartV2')

        if (this.$store.state.selected_type === 'DELIVERY') {
          const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
          if (DETAIL_LOCATION) {
            const old_detail_location = JSON.parse(DETAIL_LOCATION)
            const history = old_detail_location.history || []
            const new_detail_location = { ...old_detail_location }
            const newHash = await this.$hashLatLon(new_detail_location.shipping_lat, new_detail_location.shipping_lon)
            const existingHashes = await Promise.all(
              history.map(async item => await this.$hashLatLon(item.shipping_lat, item.shipping_lon))
            )
            if (!existingHashes.includes(newHash)) {
              delete old_detail_location.history
              history.unshift(old_detail_location) // masukkan di depan
              if (history.length > 5) history.pop() // buang yang paling lama di belakang
              new_detail_location.history = history
            }
            delete new_detail_location.name
            delete new_detail_location.driver_note
            delete new_detail_location.shipping_address
            delete new_detail_location.shipping_lat
            delete new_detail_location.shipping_lon
            delete new_detail_location.shipping_radius
            this.$store.dispatch('saveLocationV2', new_detail_location)
          }
        }

        if (this.$store.state.selected_type === 'RESERVATION') {
          this.$store.dispatch('delDetailReservationV2')
        }

        if (data.data.payment_mode_id === 10) {
          this.$router.push({ name: '_resp_order', params: { id: data.data.id }}).catch(() => {})
        } else {
          if (data.data.payment_log) {
            if (data.data.payment_log.payment_source === 'OLSERA-QRIS') {
              this.$router.push({ name: '_qris', params: { id: data.data.id }}).catch(() => {})
            } else {
              if (data.data.payment_log.checkout_url) {
                window.location = data.data.payment_log.checkout_url
              } else {
                this.$router.push({ name: '_resp_order', params: { id: data.data.id }}).catch(() => {})
              }
            }
          } else {
            this.$router.push({ name: '_resp_order', params: { id: data.data.id }}).catch(() => {})
          }
        }
        // this.resetForm()
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          const tmii_link = this.$store.state.url_domain
          if (this.tmii.indexOf(tmii_link) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else if (e.statusCode === 501) {
          if (!this.$isEmpty(this.cart)) {
            if (this.$store.state.selected_type === 'DELIVERY') {
              this.dialogChangeShippingTime = true
              this.loadShippingTime()
            }
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
      // this.disabled = false
    }
  }
}
</script>
